import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function MsStarkyGreySvg({ classNameProps, width, height }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 200 200'
      fill='none'
    >
      <rect width='200' height='200' fill='none' />
      <path
        d='M108.322 35.3201L121.822 69.2455C123.059 72.3296 125.944 74.3857 129.242 74.5913L165.722 76.9558C173.451 77.4699 176.646 87.1335 170.669 92.0681L142.535 115.302C139.959 117.358 138.929 120.75 139.753 123.937L148.718 159.302C150.676 166.807 142.432 172.769 135.837 168.657L104.921 149.227C102.139 147.48 98.5322 147.48 95.7498 149.227L64.8342 168.657C58.2389 172.769 50.0977 166.807 51.9527 159.302L61.0213 124.04C61.8457 120.853 60.7121 117.461 58.2389 115.405L30.1057 92.0681C24.1287 87.1335 27.3233 77.4699 35.0522 76.9558L71.5326 74.5913C74.8302 74.3857 77.7157 72.3296 78.9523 69.2455L92.4521 35.3201C95.2345 28.2266 105.437 28.2266 108.322 35.3201Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default MsStarkyGreySvg;
